import Loading from 'vue-loading-overlay';
import Select2Multiple from "v-select2-multiple-component";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import 'vue-loading-overlay/dist/vue-loading.css';
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import store from '../../store';
import axios from "axios";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: "PassPercentage",
    components: {
        Loading,
        Select2Multiple,
        MainLayout,
        Bar
    },

    data() {
        return {
            isLoading: false,
            passPercentage: null,
            selectedAcdYear: 0,
            yearArr: [],
            chartData: {
                labels: [],
                datasets: []
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    tooltip: {
                        callbacks: {
                          label: function(context) {
                            const value = context.parsed.y;
                            return `${context.dataset.label}: ${value}%`;
                          }
                        }
                    }
                  },
                scales: {
                    y: {
                      beginAtZero: true,
                      max: 100,
                      ticks: {
                        callback: function(value) {
                          return value + '%';
                        }
                      },
                    },
                },
            }
        };
    },

    methods: {
        changeEvent(val, fieldName) {
            if (fieldName === 'year') {
                this.selectedAcdYear = val;
            }
            this.getPassPercentageReport();
        },

        getPassPercentageReport() {
            this.isLoading = true;
            var request = {
                params: {
                    campus_id: store.state.user.campus_id,
                    acd_year_id: this.selectedAcdYear,
                }
            }
            axios.get("/report/pass-percentage", request)
                .then(response => {
                    this.chartData = {
                        ...this.chartData,
                        labels: response.data.grades,
                        datasets: [
                            {
                                label: 'Pass Students',
                                data: response.data.passed,
                                backgroundColor: ['#4CAF50']
                            },
                            {
                                label: 'Fail Students',
                                data: response.data.failed,
                                backgroundColor: ['#F44336']
                            }
                        ]
                    };
                    this.isLoading = false;
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        getCurrentPeriodList() {
            var request = {
                params: {
                    campus_id: store.state.user.campus_id,
                }
            }
            this.isLoading = true;
            axios.get('/period/getCurrentPeriodList', request)
                .then(res => {
                    if(res.data.length == 1){
                        this.selectedAcdYear = res.data[0].id;
                        this.getPassPercentageReport()
                    }else{
                        this.chartData =  {
                            labels: [],
                            datasets: []
                        };
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        getAcademicYear() {
            axios.get('getAcademicYear', {
                params: {
                    campus_id: store.state.user.campus_id
                }
            })
            .then(res => {
                let $defaultSelectOption = [{
                    'id': 0, // 0 is default (if 0, reports will result according to today)
                    'text': 'Select'
                }];
                this.yearArr = $defaultSelectOption.concat(res.data.academicYearArr);

            }).catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
            });
        },
    },

    mounted() {
        require("@/assets/plugins/css/select2.css");
        require("@/assets/css/report.css");
        this.isLoading = true;
        this.getCurrentPeriodList();
        this.getAcademicYear();
    },
};
